<div class="header-section">
  <h1 class="title">EVENTI COME<b>TRALCI</b></h1>
  <p class="subtitle">iscriviti a un evento</p>
</div>

<div class="eventi-grid">
  @for (evento of eventi; track evento.id) {
    <a
      class="evento-card"
      [routerLink]="['/eventi', evento.anno, getSlugName(evento.slug)]"
      [attr.aria-label]="'Vai all\'evento: ' + evento.titolo"
    >
      <img [src]="getImageUrl(evento)" [alt]="evento.titolo" />
      <h2 class="evento-titolo">{{ evento.titolo }}</h2>
    </a>
  }

  @if (eventi.length === 0) {
    <div class="no-eventi">
      <p>Nessun evento disponibile al momento.</p>
    </div>
  }
</div>
